<template>
  <div class="flex items-center">
    <div class="text-primary">{{ date }}</div>
  </div>
</template>

<script>
export default {
  name: 'CellRendererDate',
  computed: {
    date() {
      return this.$moment(this.params.value).format('D MMM YYYY');
    }
  }
}
</script>

<style scoped>

</style>
